import Swal from 'sweetalert2'

const Indicator = Swal.mixin({
  timerProgressBar: true,
  showConfirmButton: false,
})

const Toast = Swal.mixin({
  toast: true,
  position: 'top-right',
  iconColor: '#777',
  customClass: {
    popup: 'colored-toast',
  },
  showConfirmButton: false,
  timer: 1500,
  timerProgressBar: true
})

async function showToast (message, title, type, duration = 2500) {
  await Toast.fire({
    title: title,
    text: message,
    timer: duration,
    icon: type,
  })
}

function showErrorToast (message, title = 'Oops, something went wrong', duration = 2500) {
  showToast(message, title, 'error', duration)
}

function showInfoToast (message, title = 'Notice', duration = 2500) {
  showToast(message, title, 'info', duration)
}

function showSuccessToast (message, title = 'Success', duration = 2500) {
  showToast(message, title, 'success', duration)
}

function showWarningToast (message, title = 'Warning', duration = 2500) {
  showToast(message, title, 'warning', duration)
}

function showLoadingIndicator (message, title = 'One moment please') {
  Indicator.fire({
    title: title,
    allowOutsideClick: false,
    html: message,
    didOpen: () => {
      Indicator.showLoading()
    }
  })
}

function hideLoadingIndicator () {
  Indicator.close()
}

function closeAllToast () {
  Toast.close()
}

export {
  showToast,
  showSuccessToast,
  showErrorToast,
  showWarningToast,
  showInfoToast,
  showLoadingIndicator,
  hideLoadingIndicator,
  closeAllToast,
}